<div class="ua-container">
  <div class="search-zone" *ngIf="zone1">
    <div class="ua-filters">
      <div class="filter">
        <div class="filter-name">
          <span>Client</span>
        </div>
        <div class="filter-control">
          <select class="select-white" (change)="onChangeClientSearch($event.target.value)">
            <option value="0">Choose Client</option>
            <option #clientSearch *ngFor="let client of clientList" value={{client.id}}>{{client.name}}
            </option>
          </select>
        </div>
      </div>
      <div class="filter">
        <div class="filter-name">
          <span>Username</span>
        </div>
        <div class="filter-control">
          <input #userNameSearch type="text" class="input-control">
        </div>
      </div>
      <div class="filter filter-search">
        <div class="filter-name">
          <span>Plant</span>
        </div>
        <div class="filter-control">
          <select class="select-white" #plantSearch (change)="changePlantSearch(plantSearch.value)">
            <option value="0">Choose Plant</option>
            <option *ngFor="let plant of plantList" value={{plant.id}}>{{plant.name}}</option>
          </select>
        </div>
        <div class="filter-name">
          <span>Role</span>
        </div>
        <div class="filter-control">
          <select class="select-white" (change)="onChangeRoleSearch($event.target.value)">
            <option value="0">Choose Role</option>
            <option *ngFor="let role of roleListFilterSearch" value={{role.id}}>{{role.code}}</option>
          </select>
        </div>
      </div>
      <div>
        <button class="ua-button" (click)="Search()">Search</button>
        <button class="ua-button" (click)="AddUser()">Add</button>
      </div>
    </div>
    <div class="ua-data">
      <table>
        <caption></caption>
        <thead>
          <tr class="title-table">
            <th scope="col">Client</th>
            <th scope="col">Username</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of userListFilter" class="user-item" (click)="selectUser(user)">
            <td data-label="Client">{{user.rolname}}​</td>
            <td data-label="Username">{{user.username}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="user-detail-zone" *ngIf="zone2">
    <form [formGroup]="UserRole" (ngSubmit)="AddUserRole(UserRole.value)">
      <div class="ua-filters">
        <div class="filter">
          <div class="filter-name">
            <span>Client</span>
          </div>
          <div class="filter-control">
            <select class="select-white" formControlName="clientSelectInsertRole">
              <option *ngFor="let client of clientList" value={{client.id}}>{{client.name}}</option>
            </select>
          </div>
        </div>
        <div class="filter">
          <div class="filter-name">
            <span>Username</span>
          </div>
          <div class="filter-control">
            <span style="display: none;">{{user_id}}</span>
            <input type="text" class="input-control" value={{user_name}} formControlName="userNameInsertRole">
          </div>
        </div>
        <div *ngIf="editUser" class="filter filter-search">
          <div class="filter-name">
            <span>Plant</span>
          </div>
          <div class="filter-control">
            <select class="select-white" #plantSearchEdit (change)="changePlantEdit(plantSearchEdit.value)"
              formControlName="plantSelectInsertRole">
              <option *ngFor="let plant of plantList" value={{plant.id}}>{{plant.name}}</option>
            </select>
          </div>
          <div class="filter-name">
            <span>Role</span>
          </div>
          <div class="filter-control">
            <select class="select-white" formControlName="roleSelectInsertRole">
              <option *ngFor="let role of roleListFilterEdit" value={{role.id}}>{{role.code}}</option>
            </select>
          </div>
        </div>
        <div>
          <button class="ua-button" *ngIf="!editUser" (click)="Edit()">Edit</button>
          <button type="submit" class="ua-button" *ngIf="editUser">Add</button>
          <button class="ua-button" (click)="CancelEdit()">Cancel</button>
        </div>
      </div>
      <div class="ua-data">
        <table>
          <caption></caption>
          <thead>
            <tr>
              <th scope="col">Plant</th>
              <th scope="col">Role</th>
              <th scope="col" *ngIf="editUser">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of userDetailList?.planRole">
              <td data-label="Client">{{user.plantName}}</td>
              <td data-label="Username">{{user.roleName}}</td>
              <td data-label="Actions" (click)="DeleteUser(user.roleId)" *ngIf="editUser">
                <div>
                  <img style="height: 20px; cursor: pointer;" src="../../../../assets/images/Icons/Delete.png" alt=""
                    srcset="">
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  </div>
  <div class="user-crud-zone" *ngIf="zone3">
    <form [formGroup]="UserCatalog" (ngSubmit)="InsertUser(UserCatalog.value)">
      <div class="ua-filters">
        <div class="filter">
          <div class="filter-name">
            <span>Client</span>
          </div>
          <div class="filter-control">
            <select class="select-white" formControlName="clientSelectInsert">
              <option [ngValue]="null" disabled>Choose your Client</option>
              <option *ngFor="let client of clientList" [ngValue]=client.id>
                {{client.name}}
              </option>
            </select>
          </div>
        </div>
        <div class="filter">
          <div class="filter-name">
            <span>Username</span>
          </div>
          <div class="filter-control">
            <input type="text" class="input-control" formControlName="userNameInsert">
          </div>
        </div>
        <div class="filter filter-search">
          <div class="filter-name">
            <span>Plant</span>
          </div>
          <div class="filter-control">
            <select class="select-white" #plant (change)="plantInsertChange(plant.value)" formControlName="plantSelectInsert">
              <option *ngFor="let plant of plantList" value={{plant.id}}>{{plant.name}}</option>
            </select>
          </div>
          <div class="filter-name">
            <span>Role</span>
          </div>
          <div class="filter-control">
            <select class="select-white" formControlName="roleSelectInsert">
              <option *ngFor="let role of roleList" value={{role.id}}>{{role.code}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="ua-data">
        <table>
          <caption></caption>
          <thead>
            <tr>
              <th scope="col">Plant</th>
              <th scope="col">Role</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of userDetailList?.planRole">
              <td data-label="Client">{{user.plantName}}</td>
              <td data-label="Username">{{user.roleName}}</td>
              <td data-label="Username">X</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <button class="ua-button">Save</button>
        <button class="ua-button" (click)="GoToSearch()">Cancel</button>
      </div>
      <div id="resolution" class="resolution" style="display: none;">
        <div class="success-msg">
          <i class="fa fa-check"></i>
          Added successfully.
        </div>
      </div>
    </form>
  </div>
</div>
